
export const getDevices = state => {
    return state.devices;
}

export const getApps = state => {
    return state.apps;
}

export const getLogs = state => {
    return state.logs;
}

export const getTerminalOutput = state => {
	return state.terminalOutput;
}




















// WEBPACK FOOTER //
// ./src/store/getters.js